// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewSkus_skus-grid__S519Y {
  margin-block: 4rem 16rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 30rem));
  place-content: center;
  gap: 8rem 5rem;
  position: relative;
}

.NewSkus_skus-grid__loading__lzWQS,
.NewSkus_skus-grid__empty__OtTUY {
  margin-block: 10rem;
  position: absolute;
  right: 50%;
  transform: translate(50%);
}

.NewSkus_skus-grid__loading__lzWQS {
  width: 20rem;
  height: 20rem;
}

.NewSkus_skus-grid__empty__OtTUY .icon-wrapper {
  padding: 3rem;
}

.NewSkus_skus-grid__empty__OtTUY .icon {
  width: 6rem;
  height: 6rem;
}

.NewSkus_skus-grid__pagination__009Ol {
  margin-top: 3rem;
  grid-column: -1/1;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/NewSkus/NewSkus.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,aAAa;EACb,kDAAkD;EAClD,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":[".skus-grid {\n  margin-block: 4rem 16rem;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 30rem));\n  place-content: center;\n  gap: 8rem 5rem;\n  position: relative;\n}\n\n.skus-grid__loading,\n.skus-grid__empty {\n  margin-block: 10rem;\n  position: absolute;\n  right: 50%;\n  transform: translate(50%);\n}\n\n.skus-grid__loading {\n  width: 20rem;\n  height: 20rem;\n}\n\n.skus-grid__empty :global(.icon-wrapper) {\n  padding: 3rem;\n}\n\n.skus-grid__empty :global(.icon) {\n  width: 6rem;\n  height: 6rem;\n}\n\n.skus-grid__pagination {\n  margin-top: 3rem;\n  grid-column: -1/1;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skus-grid": `NewSkus_skus-grid__S519Y`,
	"skus-grid__loading": `NewSkus_skus-grid__loading__lzWQS`,
	"skus-grid__empty": `NewSkus_skus-grid__empty__OtTUY`,
	"skus-grid__pagination": `NewSkus_skus-grid__pagination__009Ol`
};
export default ___CSS_LOADER_EXPORT___;
